import mapboxgl from 'mapbox-gl'

function setMapLanguage(_self: any, locale: string) {
    const labels = ['country-label', 'state-label',
        'settlement-label', 'settlement-subdivision-label',
        'airport-label', 'poi-label', 'water-point-label',
        'water-line-label', 'natural-point-label',
        'natural-line-label', 'waterway-label', 'road-label']

    labels.forEach((label) => {
        _self.$refs.mapboxMap.map.setLayoutProperty(label, 'text-field', ['get', `name_${locale}`])
    })
}

function getClustersPaint() {
    return {
        'circle-color': [
            'step',
            ['get', 'point_count'],
            '#111111',
            10,
            '#111111',
            50,
            '#111111'
        ],
        'circle-radius': [
            'step',
            ['get', 'point_count'],
            20, // radio
            10, // agrupación
            30, // radio
            50, // agrupación
            40 // radio
        ],
        'circle-stroke-width': [
            'step',
            ['get', 'point_count'],
            5, // width
            10, // agrupación
            6, // width
            50, // agrupación
            7 // width
        ]
    }
}

function getClusterCountLayout() {
    return {
        'text-field': ['get', 'point_count_abbreviated'],
        'text-allow-overlap': true,
        'text-size': 14
    }
}

function getMapCenter(_self: any) {
    return _self.$refs.mapboxMap.map.getCenter()
}

function getMapZoom(_self: any) {
    return _self.$refs.mapboxMap.map.getZoom()
}

function getMapboxCustomControl(_self: any) {
    return ''
}

function mapboxActions(_self: any) {
    const zoomInElem = document.getElementById('custom-zoom-in')
    if (zoomInElem) {
        zoomInElem.onclick = () => { _self.$refs.mapboxMap.map.zoomIn() }
    }
    const zoomOutElem = document.getElementById('custom-zoom-out')
    if (zoomOutElem) {
        zoomOutElem.onclick = () => { _self.$refs.mapboxMap.map.zoomOut() }
    }
}

function addCustomControl(_self: any, place: string) {
    _self.mapboxCustomControl = new MapboxCustomControl({
        html: getMapboxCustomControl(_self)
    })
    _self.$refs.mapboxMap.map.addControl(_self.mapboxCustomControl, place)
    _self.$refs.mapboxMap.map._mapboxCustomControl = _self.mapboxCustomControl
    mapboxActions(_self)
}

function addZoomControl(_self: any) {
    const zoomControl = new mapboxgl.NavigationControl({
        showZoom: false,
        showCompass: false,
        visualizePitch: false,
    })
    _self.$refs.mapboxMap.map.addControl(zoomControl)
    _self.$refs.mapboxMap.map._zoomControl = zoomControl
}

function addFullScreenControl(_self: any) {
    _self?.$refs?.mapboxMap?.map?.addControl(new mapboxgl.FullscreenControl({}), 'top-right')
}

function addGeolocationControl(_self: any) {
    _self?.$refs?.mapboxMap?.map?.addControl(new mapboxgl.GeolocateControl({
        positionOptions: {
            enableHighAccuracy: true
        },
        trackUserLocation: true
    }))
}

function setBounds(_self: any, coords: any, padding: number = 5) {
    if (_self.$refs?.mapboxMap?.map && coords?.length) {
        const bounds = new mapboxgl.LngLatBounds()
        coords.forEach((coord: any) => {
            bounds.extend(coord)
        })
        _self.$refs.mapboxMap.map.fitBounds(bounds, {
            padding,
            maxZoom: 15,
            duration: 1
        })
    }
}

function setLine(_self: any, coords: any, sourceName: any, color: string = '#2900BB') {
    _self?.$refs?.mapboxMap?.map?.on('load', () => {
        if (_self.$refs?.mapboxMap?.map && coords && sourceName) {
            if (_self.$refs.mapboxMap.map.getSource(sourceName)) {
                _self.$refs.mapboxMap.map.removeLayer(sourceName)
                _self.$refs.mapboxMap.map.removeSource(sourceName)
            }
            _self.$refs.mapboxMap.map.addSource(sourceName, {
                type: 'geojson',
                data: {
                    id: Math.round(Math.random() * 1000),
                    type: 'Feature',
                    geometry: {
                        type: 'LineString',
                        coordinates: coords
                    }
                }
            })
            _self.$refs.mapboxMap.map.addLayer({
                id: sourceName,
                type: 'line',
                source: sourceName,
                layout: {
                    'line-join': 'round',
                    'line-cap': 'round',
                    'line-sort-key': 1
                },
                paint: {
                    'line-color': color,
                    'line-width': 2,
                    'line-opacity': 1
                }
            })
            const firstClusterLayer = _self.$refs.mapboxMap?.map?.getStyle()?.layers?.find((layer: { id: string | string[] }) => {
                return layer.id.includes('mb')
            }) ?? undefined
            if (firstClusterLayer) {
                _self.$refs.mapboxMap.map.moveLayer(sourceName, firstClusterLayer.id)
            }
        } else if (_self.$refs?.mapboxMap?.map && sourceName) {
            if (_self.$refs.mapboxMap.map.getSource(sourceName)) {
                _self.$refs.mapboxMap.map.removeLayer(sourceName)
                _self.$refs.mapboxMap.map.removeSource(sourceName)
            }
        }
    })
}

function initMap(_self: any, place = 'top-right') {
    _self?.$refs?.mapboxMap?.map?.on('load', () => {
        setMapLanguage(_self, _self.$i18n.locale)
        addZoomControl(_self)
        if (['index',
            'experiences',
            'experiences-id',
            'destinations',
            'destinations-id',
            'activities',
            'activities-id',
            'restaurants',
            'restaurants-id',
            'accommodations',
            'accommodations-id',
            'tours',
            'tours-id',
            'your-itineraries-id'].includes(_self.route.name)) {
            addFullScreenControl(_self)
        }
        if (['index',
            'experiences-id',
            'destinations-id',
            'accommodations-id',
            'tours-id',
            'restaurants-id',
            'activities-id',
            'your-itineraries-id'].includes(_self.route.name)) {
            addGeolocationControl(_self)
        }
        addCustomControl(_self, place)
    })
}

export function getMapboxInitialVariables() {
    return {
        mapStyle: 'mapbox://styles/mapbox/streets-v11',
        defaultCenter: [-3.703284, 40.417372],
        initMap,
        setLine,
        setBounds,
        addFullScreenControl,
        addGeolocationControl,
        getClustersPaint,
        getClusterCountLayout,
        getMapCenter,
        getMapZoom
    }
}